import axios from './http';
import { CancelTokenSource } from 'axios';
import { TenantDto } from '../ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/tenants`;

export const searchTenants = (query: String,
                              source: CancelTokenSource): Promise<Array<TenantDto>> => {
  return axios
      .get(`${apiUri}?query=${query}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getTenants = (): Promise<Array<TenantDto>> => {
  return axios
      .get(apiUri)
      .then((response) => response.data);
};

export const findTenantById = (id: string, source: CancelTokenSource): Promise<TenantDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const addTenant = (upsertTenantsettingsDto: Partial<TenantDto>, source: CancelTokenSource): Promise<TenantDto> => {
  return axios
      .post(apiUri, upsertTenantsettingsDto)
      .then(response => response.data);
};

export const deleteTenant = (id: string, cancelTokenSource: CancelTokenSource) => {
  return axios
      .delete(`${apiUri}/${id}`);
};

export const editTenant = (id: string, upsertTenantsettingsDto: Partial<TenantDto>, source: CancelTokenSource): Promise<TenantDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertTenantsettingsDto)
      .then(response => response.data);
};

export const getDatabaseNames = (): Promise<string[]> => {
  return axios.get<string[]>(`${apiUri}/databases`)
      .then(response => response.data);
};
